import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {FehlermeldungApiModel} from 'cargo-hub-ui-customer-api';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {DEFAULT_CARGO_API_VERSION} from '../../environments/environment.model';
import {ErrorService} from '../cd-common/service/error.service';
import {NotificationHelper} from '../root-store/notification/notification-helper';
import {notificationCreate} from '../root-store/notification/notification.actions';
import {generateUniqueID} from '../util/generalFunctions';
import {isBackendUrl} from './interceptors-helper';
import SystemApiModelEnum = FehlermeldungApiModel.SystemApiModelEnum;

@Injectable()
export class VersionCheckInterceptor implements HttpInterceptor {
  readonly apiVersion: string;

  /// reuse same ID for all notifications to assure at most one notification of this type is visible
  private notificationId = generateUniqueID();

  constructor(private store: Store) {
    this.apiVersion = environment.version.indexOf('.') > 0 ? `v${environment.version.substring(0, environment.version.indexOf('.'))}` : DEFAULT_CARGO_API_VERSION;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isBackendUrl(req.url)) {
      const modifiedReq = req.clone({
        headers: req.headers.append('x-capri-apiversion', this.apiVersion)
      });
      return next.handle(modifiedReq).pipe(tap({next: value => this.handleVersionMismatch(value), error: error => this.handleVersionMismatch(error)}));
    } else {
      return next.handle(req);
    }
  }

  private handleVersionMismatch(value: HttpEvent<unknown> | HttpErrorResponse) {
    if (value instanceof HttpErrorResponse) {
      if (
        value.status === HttpStatusCode.Conflict &&
        ErrorService.isCargoError(value.error) &&
        value.error.meldungen?.[0]?.system === SystemApiModelEnum.Api &&
        value.error.meldungen?.[0]?.code === 'MAJOR VERSION MISMATCH'
      ) {
        this.store.dispatch(
          notificationCreate({
            notification: NotificationHelper.createCDNotification({
              id: this.notificationId,
              type: 'error',
              showInNotificationCenter: true,
              title: $localize`:@@VERSION_MISMATCH_ERROR_TITLE:Bitte laden Sie die Seite neu.`,
              message: $localize`:@@VERSION_MISMATCH_ERROR_MESSAGE:Es wurde eine neue Version ausgerollt.`
            })
          })
        );
      }
    }
  }
}
